

define(['squid/index', 'text!./template.html'], function (squid, template, opinionlab) {

    squid.module('xo-login-button.directive', ['squid']).directive('xoLoginButton', function () {

        return {
            template: template,

            scope: {
                redirect: '='
            },

            controller: function controller($scope) {}
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/login-button/directive.js
// module id = ./components/xo-guest-components/src/login-button/directive.js
// module chunks = 1